import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  src: string;
  username: string;
  type?: 'organization';
}

const IconWrapper = styled.div`
  display: inline-block;
  line-height: 0;
`;

export class Avatar extends React.PureComponent<IProps, {}> {
  public render() {
    const { src, username, type } = this.props;
    if (src) {
      return (
        <IconWrapper>
          <kz-avatar src={src} username={username} />
        </IconWrapper>
      );
    } else {
      if (type === 'organization') {
        return (
          <IconWrapper>
            <kz-icon-building />
          </IconWrapper>
        );
      } else {
        return (
          <IconWrapper>
            <kz-icon-user-circle />
          </IconWrapper>
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/Avatar.tsx